jQuery(document).ready(function($) {

  // start login code
  
  $('.customerlogin #LoginSection .otpbtn').click(function() {    
    $('.customerlogin #LoginSection .otpbtn').find('div:first').css('display','none');
    $('#loader-submit').css("display", "inline-block");
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var cc = $('#countrycode').val();
    var phNo = $('#RegisterForm-PhoneNumber').val();
    var mobile_number = cc+phNo;
    mobile_number = mobile_number?.replace(/\+/g, "")?.replace(/\s/g, "");
    if(cc && phNo) {
      var data = {
        mobile: mobile_number,
      }
      $.ajax({
        url: 'https://app.platinexpress.co.il/api/login_send_otp',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: function(result) {
          if(result.status == 'SUCCESS'){
            $('.customerlogin #LoginSection').css('display','none');
            $('.customerlogin .register-link').css('display','none');
            $('.customerlogin #otpsection').css('display','block');
            $('#login-phonenumber').html(mobile_number + '+');
            $('.customerlogin #LoginSection .otpbtn').find('div:first').css('display','block');
            $('#loader-submit').css("display", "none");
          } else {
            $('.customerlogin #LoginSection .otp-error').css('display','block');
           $('.customerlogin #LoginSection .otpbtn').find('div:first').css('display','block');
            $('#loader-submit').css("display", "none");
          }
        },
        error: function(result) {
          $('.customerlogin #LoginSection .dynamic-error').html(result.responseJSON.message);
          $('.customerlogin #LoginSection .otp-error').css('display','none');
          $('.customerlogin #LoginSection .otpbtn').find('div:first').css('display','block');
          $('#loader-submit').css("display", "none");
        }
      });
    } else {
      $('.customerlogin #LoginSection .otp-error').css('display','block');
      $('.customerlogin #LoginSection .otpbtn').find('div:first').css('display','block');
      $('#loader-submit').css("display", "none");
    }
  });

$(".otp-number").keyup(function () {
    // if (this.value.length == this.maxLength) {
    //   $(`#otp-${this.id.split('-')[1] - 1}`).focus();
    // }
  if (this.value.length == this.maxLength) {
      const nextIndex = parseInt(this.id.split('-')[1]) + 1;
      $(`#otp-${nextIndex}`).focus();
  } else {
      const prevIndex = parseInt(this.id.split('-')[1]) - 1;
      if (prevIndex >= 1) {
          $(`#otp-${prevIndex}`).focus();
      }
  }
});
  
  $('.customerlogin #otpsection #editphnnumber').click(function() {
    $('.customerlogin #otpsection').css('display','none');
    $('.customerlogin #LoginSection').css('display','block');
    $('.customerlogin .register-link').css('display','block');
    // $('#sixdigitotp').val('');
    $('#otp-1').val('');
    $('#otp-2').val('');
    $('#otp-3').val('');
    $('#otp-4').val('');
    $('#otp-5').val('');
    $('#otp-6').val('');
  });

  // $('#sixdigitotp').on('input', function() {
  //   var otpValue = $(this).val();
  //   if (otpValue.length === 4) {
  //     // Automatically trigger form submission
  //     $('.customerlogin #otpsection #otpsubmit').trigger('click');
  //   }
  // });
    
    $('.customerlogin #otpsection #otpsubmit').click(function(event) {
      $('.customerlogin #otpsection #otpsubmit').find('div:first').css('display','none');
      $('#loader-submit').css("display", "inline-block");
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var cc = $('#countrycode').val();
      var phNo = $('#RegisterForm-PhoneNumber').val();
      var mobile_number = cc+phNo;
      mobile_number = mobile_number?.replace(/\+/g, "")?.replace(/\s/g, "");
      var otp_val1 = $('#otp-1').val();
      var otp_val2 = $('#otp-2').val();
      var otp_val3 = $('#otp-3').val();
      var otp_val4 = $('#otp-4').val();
      var otp_val5 = $('#otp-5').val();
      var otp_val6 = $('#otp-6').val();
      var otp_val = otp_val1 + otp_val2 + otp_val3 + otp_val4 + otp_val5 + otp_val6;
      if(cc && phNo && otp_val) {
        var otp_data = {
          mobile: mobile_number,
          otp: otp_val
        }
        $.ajax({
          url: 'https://app.platinexpress.co.il/api/login_verify_otp',
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(otp_data),
          success: function(result) {
            if(result.status == 'SUCCESS'){
              window.location.href = result.data.url;
              $('.customerlogin #otpsection #otpsubmit').find('div:first').css('display','block');
              $('#loader-submit').css("display", "none");
            } else {
              $('.customerlogin .otpinputfield .login-otp-error').css('display','block');
              $('.customerlogin #otpsection #otpsubmit').find('div:first').css('display','block');
              $('#loader-submit').css("display", "none");
            }
          },
          error: function(result) {
            $('.customerlogin .otpinputfield .login-otp-error').css('display','block');
            $('.customerlogin #otpsection #otpsubmit').find('div:first').css('display','block');
            $('#loader-submit').css("display", "none");
          }
        });
      } else {
        $('.customerlogin .otpinputfield .login-otp-error').css('display','block');
        $('.customerlogin #otpsection #otpsubmit').find('div:first').css('display','block');
        $('#loader-submit').css("display", "none");
      }
    });

    $('.customerlogin #otpsection #resendOTPButton').click(function(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      $('#sixdigitotp').val('');
      $('.customerlogin #LoginSection .otpbtn').trigger('click');
    });
  
  //end login code

  //start register code

  function generateRandomPassword(length) {
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset.charAt(randomIndex);
    }
    return password;
  }

  $('.customer-register #LoginSection .regiotpbtn').click(function() {
    $('.customer-register #LoginSection .regiotpbtn').find('div:first').css('display','none');
    $('#loader-get-otp').css("display", "inline-block");
    var cc = $('#countrycode').val();
    var phNo = $('#RegisterForm-PhoneNumber').val();
    var mobile_number = cc+phNo;
    mobile_number = mobile_number?.replace(/\+/g, "")?.replace(/\s/g, "");
    if(cc && phNo) {
      var data = {
        mobile: mobile_number,
      }
      $.ajax({
        url: 'https://app.platinexpress.co.il/api/register_send_otp',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: function(result) {
          if(result.status == 'SUCCESS'){
            $('.customer-register #LoginSection').css('display','none');
            $('.customer-register .login-link').css('display','none');
            $('.customer-register .register-otp').css('display','block');
            $('#phonenumber').html(mobile_number + '+');
            $('.customer-register #LoginSection .regiotpbtn').find('div:first').css('display','block');
            $('#loader-get-otp').css("display", "none");
          } else {
            $('.customer-register #LoginSection .custome-otp-error').html(result.responseJSON.message);
            $('.customer-register #LoginSection .regiotpbtn').find('div:first').css('display','block');
            $('#loader-get-otp').css("display", "none");
          }
        },
        error: function(result) {
          $('.customer-register #LoginSection .custome-otp-error').html(result.responseJSON.message);
          $('.customer-register #LoginSection .regiotpbtn').find('div:first').css('display','block');
          $('#loader-get-otp').css("display", "none");
        }
      });
    } else {
      $('.customer-register #LoginSection .otp-error').css('display','block');
      $('.customer-register #LoginSection .regiotpbtn').find('div:first').css('display','block');
      $('#loader-get-otp').css("display", "none");
    }
  });

    $('.customer-register .register-otp .register-num-edit').click(function() {
      $('.customer-register .register-otp').css('display','none');
      $('.customer-register #LoginSection').css('display','block');
      $('.customer-register .login-link').css('display','block');
      $('#sixdigitotp').val('');
    });
  
    $('.customer-register #otpsection .register-verify-otp').click(function() {
      $('.customer-register #otpsection .register-verify-otp').find('div:first').css('display','none');
      $('#loader-verify').css("display", "inline-block");
      var cc = $('#countrycode').val();
      var phNo = $('#RegisterForm-PhoneNumber').val();
      var mobile_number = cc+phNo;
      mobile_number = mobile_number?.replace(/\+/g, "")?.replace(/\s/g, "");
      var otp_val1 = $('#otp-1').val();
      var otp_val2 = $('#otp-2').val();
      var otp_val3 = $('#otp-3').val();
      var otp_val4 = $('#otp-4').val();
      var otp_val5 = $('#otp-5').val();
      var otp_val6 = $('#otp-6').val();
      var otp_val = otp_val1 + otp_val2 + otp_val3 + otp_val4 + otp_val5 + otp_val6;
      if(cc && phNo && otp_val) {
        var otp_data = {
          mobile: mobile_number,
          otp: otp_val
        }
        $.ajax({
          url: 'https://app.platinexpress.co.il/api/register_verify_otp',
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(otp_data),
          success: function(result) {
            if(result.status == 'SUCCESS'){
              $('.customer-register .register-otp').css('display','none');
              $('.customer-register .register-form').css('display','block');
              $('#phnnumber').html(mobile_number + '+');
              $('.customer-register #otpsection .register-verify-otp').find('div:first').css('display','block');
              $('#loader-verify').css("display", "none");
            } else {
              $('.customer-register .otpinputfield .registr-otp-error').css('display','block');
              $('.customer-register #otpsection .register-verify-otp').find('div:first').css('display','block');
              $('#loader-verify').css("display", "none");
            }
          },
          error: function(result) {
            $('.customer-register .otpinputfield .registr-otp-error').css('display','block');
            $('.customer-register #otpsection .register-verify-otp').find('div:first').css('display','block');
            $('#loader-verify').css("display", "none");
          }
        });
      } else {
        $('.customer-register .otpinputfield .registr-otp-error').css('display','block');
        $('.customer-register #otpsection .register-verify-otp').find('div:first').css('display','block');
        $('#loader-verify').css("display", "none");
      }
    });

    $('.customer-register #otpsection #resendregotp').click(function(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      $('#sixdigitotp').val('');
      $('.customer-register #LoginSection .regiotpbtn').trigger('click');
    });

  $('#sixdigitotp').on('input', function() {
    var otpValue = $(this).val();
    if (otpValue.length === 4) {
      // Automatically trigger form submission
      $('.customer-register #otpsection .register-verify-otp').trigger('click');
    }
  });

    $('.customer-register #register-btn').click(function(event) {
      $('.customer-register #register-btn').find('div:first').css('display','none');
      $('#loader-register').css("display", "block");
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var form = $(this).closest("form");
      var email = form.find('#RegisterForm-email').val();
      const newPassword = generateRandomPassword(8);
      $('<input>').attr('type','hidden').attr('name','customer[password]').attr('value',newPassword).insertAfter('.register-user .form-control');
      var cc = $('#countrycode').val();
      var phNo = $('#RegisterForm-PhoneNumber').val();
      var mobile_number = cc+phNo;
      mobile_number = mobile_number?.replace(/\+/g, "")?.replace(/\s/g, "");
      if(mobile_number && email) {
          var data = {
          email: email,
          password: $('input[name="customer[password]"]').val(),
          mobile: mobile_number
        }
        $.ajax({
          url: 'https://app.platinexpress.co.il/api/register_addEmail',
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(data),
          success: function(result) {
            form.submit()
            $(".customer-register #registermessage").html(result.responseJSON.message);
            $('.customer-register #register-btn').find('div:first').css('display','block');
            $('#loader-register').css("display", "none");
          },
          error: function(result) {
            $('.customer-register .register-form .register-user #register-emailsection .email-error').css('display','block');
            $('.customer-register #register-btn').find('div:first').css('display','block');
            $('#loader-register').css("display", "none");
          }
        });
      } else {
        $('.customer-register .register-form .register-user #register-emailsection .email-error').css('display','block');
        $('.customer-register #register-btn').find('div:first').css('display','block');
        $('#loader-register').css("display", "none");
      }
    });

  //end register code
    
  });